import { PropsWithChildren, ReactElement } from 'react';

export type PartialFunctionComponent<P = {}> = (
  props: PropsWithChildren<P>,
  context?: any,
) => Partial<ReactElement<any, any>> | null;
